import { useMutation } from '@tanstack/react-query'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { postHppRemoteWalletProviders } from 'services/HppSettingsService'
import type { RemoteWalletProvidersPayload } from 'types/hppSettings'
import { logSentryError } from 'utils/sentry'

export const useUpdateHppRemoteWalletProvidersMutation = () => {
  const { currentAccount } = useAccountsContext()

  return useMutation({
    mutationFn: (data: Omit<RemoteWalletProvidersPayload, 'ownerId'>) =>
      postHppRemoteWalletProviders({
        ...data,
        ownerId: currentAccount?.reference,
      }),
    onError(error, data) {
      logSentryError('Error from useUpdateHppRemoteWalletProvidersMutation', error, data)
    },
  })
}
